<template>
  <div>
    <!-- <ActivityFlowCard
      card_title="Ventas"
      :data="reportData"
      :map-data="{ title: 'Title', qty: 'Qty' }"
      :loading="loading"
      extraClass="bg-danger"
      @click-item-qty="handleClickLink"
    >
    </ActivityFlowCard> -->
    <el-card
      class="box-card activity"
      shadow="hover"
      :body-style="{ padding: '0 20px 0 20px' }"
      v-loading="loading"
    >
      <div slot="header" class="clearfix stats">
        <div class="box title">VENTAS</div>
        <el-button type="text" class="box" @click="$emit('push-add')"
          ><i class="mdi mdi-plus-circle-outline" style="font-size: 24px"></i
        ></el-button>
      </div>

      <!--:row-style="{ padding-top: '-30px'; padding-bottom: '-30px;' }"   :row-class-name="ChangeRow"-->
      <!-- <rabbey-table-3 :data="DataMock" :columns="MockColumns" /> -->

      <el-table :data="reportData" :show-header="false" style="width: 100%">
        <el-table-column prop="Title"> </el-table-column>

        <el-table-column prop="Qty" width="70" align="right">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleClickLink(scope.row)">
              {{ scope.row.Qty }}
              <!-- <span v-if="`${scope.row.Qty}`.includes('.')">{{
              scope.row.Qty | formatterMoney
            }}</span>
            <span v-else-if="scope.row.Qty > 0">{{ scope.row.Qty }}</span> -->
            </el-link>
          </template>
        </el-table-column>
        <!-- <el-table-column
        v-for="(column, index) in MockColumns"
        :key="index"
        :formatter="
          typeof column.formatter === 'function' ? column.formatter : null
        "
        v-bind="column"
      /> -->
      </el-table>
    </el-card>

    <el-drawer
      :visible.sync="drawer"
      size="80%"
      :title="title"
      @closed="OnClose"
      :destroy-on-close="true"
    >
      <div v-if="title != 'Oportunidades vencidas'" style="padding: 30px">
        <!-- Para detalles de Oportunidades Vencidas -->
        <el-row style="text-align: center">
          <el-col
            :xs="8"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="8"
            v-show="getTotalAmount"
          >
            <h3>Total de Reportes: {{ getTotalReports }}</h3>
          </el-col>
          <el-col
            :xs="8"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="8"
            v-show="getTotalAmount"
          >
            <h3>Cantidad de terminal: {{ getTotalQuantity }}</h3>
          </el-col>
          <el-col
            :xs="8"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="8"
            v-show="getTotalAmount"
          >
            <h3>Monto Total: {{ getTotalAmount | formatterMoney }} US</h3>
          </el-col>
        </el-row>

        <!-- Para los demas detalles -->
        <CardStatDrawerHeader
          :itemQuantity="itemQuantity"
          :Title="title"
          v-if="getTotalAmount2"
        />

        <rabbey-toolbox :filterables="true" @filter-search="search = $event" />

        <rabbey-table3
          style="margin: 30px"
          :data="items"
          :search="search"
          :columns="columns"
          :max-height="700"
          :actions="actions"
          @rtable-push-action="onPushAction"
          :page-sizes="[10, 30, 50, 100, 500]"
        ></rabbey-table3>
      </div>
      <div v-else style="padding: 30px">
        <el-row>
          <el-col>
            <rabbey-toolbox
              style="margin-top: 50px"
              :filterables="true"
              @filter-search="search = $event"
            />

            <rabbey-table3
              style="margin: 30px"
              ref="table"
              :loading="loading"
              :data="OportuinitiesData"
              :search="search"
              :columns="columns"
              :actions="actions"
              :max-height="700"
              @rtable-push-action="onPushAction"
            >
            </rabbey-table3>
          </el-col>
        </el-row>
      </div>
      <DealsFormDrawer
        ref="form_view"
        :title="dealDetailTitle"
        :drawer.sync="dealDetailDrawer"
        :loading="true"
        :append-to-body="true"
        v-bind="dealDetailBind"
        @close-drawer="CloseDetailDrawer"
        @refresh-table="handleTableUpdate"
      />
    </el-drawer>
  </div>
</template>

<script>
import axios from "axios";
// import ActivityFlowCard from "@/components/activity_flow/ActivityFlowCard.vue";
import {
  requestColumns,
  diaryColumns,
  dealColumns,
  customerCardsSales,
  requestColumnsDTO,
  anniversaryColumns,
  missingAnniversaryColumns,
  expiredDeals,
  RequestInstalations,
  ProspectAndOther
} from "@/columns";
// import { helperGetColumsItems } from "./utils.js";
import CardStatDrawerHeader from "./CardStatDrawerHeader.vue";
// import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
// import DatetimeFormatterColor from "@/components/functionals/DatetimeFormatterColor.vue";
// import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import DealsFormDrawer from "@/components/deals/DealsFormDrawer.vue";
import Deal from "@/models/deals/Deal";
import LinkFormatter from "@/components/functionals/CashFlowHyperlink.vue";
/*
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
*/

export default {
  name: "SalesStat",
  props: {
    employee: {
      type: [String, Number]
    },
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // ActivityFlowCard,
    CardStatDrawerHeader,
    DealsFormDrawer
  },
  data() {
    return {
      dealDetailTitle: "",
      dealDetailDrawer: false,
      dealDetailBind: {
        initModel: Deal
      },
      drawer: false,
      loading: false,
      reportData: [],
      OportuinitiesData: [],
      items: [],
      dueOportunitiesColumns: [
        // {
        //   prop: "DealsId",
        //   label: "NO",
        //   width: 70,
        //   align: "center",
        //   fixed: true
        // },
        // {
        //   prop: "DealDescription",
        //   label: "Descripción de Oportunidad",
        //   minWidth: 225
        // },
        // {
        //   prop: "Quantity",
        //   label: "Cantidad",
        //   width: 110
        // },
        // {
        //   prop: "UnitPrice",
        //   label: "P. Unitario",
        //   width: 110
        //   // formatter: row => formatterMoney(row.UnitPrice)
        // },
        // {
        //   prop: "TotalAmount",
        //   label: "Monto total",
        //   width: 100
        //   // formatter: row => formatterMoney(row.Amount)
        // },
        // // {
        // //   prop: "Currency.Name",
        // //   label: "Moneda",
        // //   width: 100
        // //   // formatter: row => (row.Currency ? row.Currency.Name : "")
        // // },
        // {
        //   label: "Contacto",
        //   prop: "ContactName",
        //   minWidth: 200
        // },
        // {
        //   prop: "InitialDate",
        //   label: "Fecha de propuesta",
        //   formatter: DatetimeFormatter,
        //   width: 180
        // },
        // {
        //   prop: "FinalDate",
        //   label: "Fecha de cierre",
        //   formatter: DatetimeFormatterColor,
        //   width: 180
        // },
        // {
        //   prop: "SalesPersonName",
        //   label: "Vendedor",
        //   minWidth: 200,
        //   formatter: ImagePersonVue,
        //   attrs: {
        //     imgKey: "SalesPersonPhoto"
        //   }
        // },
        // {
        //   prop: "SupportSellerName",
        //   label: "Soporte de venta",
        //   width: 250,
        //   formatter: ImagePersonVue,
        //   attrs: {
        //     imgKey: "SupportSellerPhoto"
        //   }
        // }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view",
          condition: () =>
            this.title == "Oportunidades vencidas" ||
            this.title == "Cierres Del Mes" ||
            this.title == "Cierres de la semana"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit",
          condition: () =>
            (this.IsInRoles([
              this.roles.Admin,
              this.roles.SuperUsuario,
              this.roles.CEO,
              this.roles.SupervisorDeVentas,
              this.roles.SupervisorDeSoporteDeVentas
            ]) &&
              this.title == "Oportunidades vencidas") ||
            (this.IsInRoles([
              this.roles.Admin,
              this.roles.SuperUsuario,
              this.roles.CEO,
              this.roles.SupervisorDeVentas,
              this.roles.SupervisorDeSoporteDeVentas
            ]) &&
              this.title == "Cierres Del Mes") ||
            (this.IsInRoles([
              this.roles.Admin,
              this.roles.SuperUsuario,
              this.roles.CEO,
              this.roles.SupervisorDeVentas,
              this.roles.SupervisorDeSoporteDeVentas
            ]) &&
              this.title == "Cierres de la semana")
        }
      ],
      columns: [
        /*
        {
          prop: "Id",
          label: "NO",
          width: 70,
          align: "center",
          fixed: true,
          sortable: true
        },
        {
          prop: "Name",
          label: "Negociación",
          minWidth: 300
        },
        {
          label: "Contacto",
          prop: "ContactName",
          minWidth: 200
        },
        {
          prop: "Product.Description",
          label: "Producto",
          minWidth: 100
        },
        {
          prop: "UnitPrice",
          label: "P. Unitario",
          width: 110
        },
        {
          prop: "Quantity",
          label: "Cantidad",
          width: 110,
          sortable: true
        },
        {
          prop: "Amount",
          label: "Monto total",
          width: 130,
          sortable: true
        },
        {
          prop: "Currency.Name",
          label: "Moneda",
          width: 100
        },
        {
          prop: "InitialDate",
          label: "Fecha de creacion",
          formatter: DatetimeFormatter,
          width: 180
        },
        {
          prop: "FinalDate",
          label: "Fecha de cierre",
          formatter: DatetimeFormatter,
          width: 180
        },
        {
          prop: "Seller.FullName",
          label: "Vendedor",
          formatter: ImagePerson,
          minWidth: 200,
          attrs: {
            imgKey: "SalesPersonPhoto"
          }
        },
        {
          prop: "CreatedByUser.FullName",
          label: "Creador",
          formatter: ImagePerson,
          minWidth: 250,
          attrs: {
            imgKey: "CreatedPersonPhoto"
          }
        },
        {
          label: "Sop. Ventas",
          prop: "SupportSeller.FullName",
          minWidth: 250,
          formatter: ImagePerson,
          attrs: {
            imgKey: "SupportSellerPhoto"
          }
        }
        */
      ],
      title: "",
      search: "",
      itemQuantity: 0,
      totalAmount: 0,
      request: null,
      mapColumns: {
        Data: dealColumns,
        Requests: requestColumns,
        RequestsDto: requestColumnsDTO,
        Agenda: diaryColumns,
        Customers: customerCardsSales,
        Anniversaries: anniversaryColumns,
        MissingAnniversaries: missingAnniversaryColumns,
        dataSalesDetailsProspectPresentation: ProspectAndOther
      },
      MockColumns: [
        {
          prop: "columnTitle"
        },
        {
          prop: "Qty",
          width: "50",
          formatter: LinkFormatter
        }
      ]
      /*
      DataMock: [
        {
          columnTitle: "Clientes sin llamar",
          Qty: "254"
        },
        {
          columnTitle: "Clientes sin visitar",
          Qty: "42"
        },
        {
          columnTitle: "Oportunidades vencidas",
          Qty: "3"
        },
        {
          columnTitle: "Cierres de la semana",
          Qty: "12"
        },
        {
          columnTitle: "Cierres del mes",
          Qty: "350"
        },
        {
          columnTitle: "Instalaciones abiertas",
          Qty: "45"
        },
        {
          columnTitle: "Instalaciones cerradas del mes",
          Qty: "164"
        },
        {
          columnTitle: "Citas de la semana",
          Qty: "984"
        },
        {
          columnTitle: "Citas del mes",
          Qty: "458"
        },
        {
          columnTitle: "Aniversarios de clientes en el mes actual",
          Qty: "678"
        },
        {
          columnTitle: "Contactos sin fecha de cumpleaños",
          Qty: "675"
        }
      ]
      */
    };
  },
  created() {
    this.getReportData();
  },
  methods: {
    handleClick() {
      this.drawer = true;
    },
    getReportData() {
      this.loading = true;

      if (this.request) {
        this.request.cancel();
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      this.$http
        .get("/api/MessageApi/GetSalesStat", {
          cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000,
          params: {
            CompanyCode: this.currentCompany,
            UserName: this.currentUser.UserName,
            SellerCode: this.currentUser.PersonCode,
            EmployeeId: this.employee,
            year: new Date().getFullYear(),

            month: new Date().getMonth()
            //month: new Date().getMonth()
          }
        })
        .then((resp) => {
          this.reportData = resp.data;
          // console.log("data",this.employee)
          this.loading = false;
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.loading = false;
        });
    },
    async onPushAction(c) {
      var { data } = await this.$http.get("/api/deals/GetByID/", {
        timeout: 3 * 60 * 1000,
        params: {
          DealsId: c.row.DealsId
        }
      });

      const isClient = data.CustomerCode
        ? data.CustomerCode.startsWith("CL")
        : false;
      const isProspect = data.CustomerCode
        ? data.CustomerCode.startsWith("C0")
        : false;
      const code = data.CustomerCode ?? "";

      switch (c.command) {
        case "view": {
          this.dealDetailTitle = `Detalle de Oportunidad # ${c.row.DealsId}`;
          this.dealDetailBind.isClient = isClient;
          this.dealDetailBind.isProspect = isProspect;
          this.dealDetailBind.code = code;
          this.dealDetailBind.initModel = JSON.parse(JSON.stringify(c.row));
          this.dealDetailBind.initModel = {
            ...data
          };
          this.dealDetailBind.isEdit = false;
          this.dealDetailBind.isView = true;
          this.dealDetailDrawer = true;
          break;
        }

        case "edit": {
          this.dealDetailTitle = `Detalle de Oportunidad # ${c.row.DealsId}`;
          this.dealDetailBind.isClient = isClient;
          this.dealDetailBind.isProspect = isProspect;
          this.dealDetailBind.code = code;
          this.dealDetailBind.initModel = {
            ...data
          };
          this.dealDetailBind.isView = false;
          this.dealDetailBind.isEdit = true;
          this.dealDetailDrawer = true;
          break;
        }

        default:
          break;
      }
    },
    GetDetailsData(option) {
      let Parameters = {
        params: {
          CompanyCode: this.currentCompany,
          SellerCode: this.currentUser.PersonCode,
          EmployeeId: this.employee,
          year: new Date().getFullYear(),
          month: new Date().getMonth(),
          option: option
        }
      };

      this.loading = true;

      this.$http
        .get("/api/MessageApi/GetSalesStatDetails", Parameters)
        .then((response) => {
          // console.log("data citas del mes ",response.data)
          switch (option) {
            case "v":
            case "l": {
              this.items = response.data[0].Customers;
              // console.log("data visitas o llamadas: ", this.items);
              this.itemQuantity = this.items.length;
              break;
            }
            // case "l": {
            //   console.log("Entre a llamadas");
            //   this.items = response.data[0].Customers;
            //   break;
            // }
            case "o": {
              this.OportuinitiesData = response.data[0].ExpiredData;
              this.itemQuantity = this.items.length;
              break;
            }
            case "w":
            case "m": {
              this.items = response.data[0].ExpiredData;
              this.itemQuantity = this.items.length;
              this.totalAmount = this.items.length;
              break;
            }
            case "i":
            case "c": {
              this.items = response.data[0].RequestsInstall;
              this.itemQuantity = this.items.length;
              break;
            }
            case "d":
            case "p": {
              this.items = response.data[0].Appointments;
              this.itemQuantity = this.items.length;
              break;
            }
            /*
            case "a": {
              console.log("Entre a citas");
              this.items = response.data[0].Anniversaries;
              break;
            }
            */
            case "a":
            case "f": {
              this.items = response.data[0].MissingAnniversaries;
              this.itemQuantity = this.items.length;
              break;
            }

            case "r": {
              this.items =
                response.data[0].dataSalesDetailsProspectPresentation;
              this.itemQuantity = this.items.length;
              break;
            }

            case "s": {
              this.items =
                response.data[0].dataSalesDetailsProspectPresentation;
              this.itemQuantity = this.items.length;
              break;
            }

            case "t": {
              this.items =
                response.data[0].dataSalesDetailsProspectPresentation;
              this.itemQuantity = this.items.length;
              break;
            }

            case "u": {
              this.items =
                response.data[0].dataSalesDetailsProspectPresentation;
              this.itemQuantity = this.items.length;
              break;
            }

            case "k": {
              this.items =
                response.data[0].dataSalesDetailsProspectPresentation;
              this.itemQuantity = this.items.length;
              break;
            }

            case "j": {
              this.items =
                response.data[0].dataSalesDetailsProspectPresentation;
              this.itemQuantity = this.items.length;
              break;
            }
            default: {
              console.error("Se recibio una opcion no valida");
              break;
            }
          }

          this.loading = false;
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.loading = false;
        });
    },
    handleClickLink(props) {
      // const report = this.DataMock.find((f) => f.columnTitle === props.columnTitle);
      // const { items, columns } = helperGetColumsItems(report, this.mapColumns); // columns.splice(13, 1); // console.log("Colummna eliminada: ",columnas);
      /*
      console.log("Items: ",items);
      */
      //console.log("Columns: ",columns);

      /* const columnas = */

      this.title = props.Title;
      this.totalAmount = props.qty; // Gets total items to display it on the header of the drawer
      // Gets total items to display it on the header of the drawer
      //this.GetOportunitiesData();

      this.columns = [];
      switch (props.Title) {
        case "Clientes sin Llamadas": {
          this.columns = customerCardsSales;
          let option = "l";
          this.GetDetailsData(option);
          break;
        }
        case "Clientes sin Visitas": {
          this.columns = customerCardsSales;
          let option = "v";
          this.GetDetailsData(option);
          break;
        }

        case "Oportunidades vencidas": {
          this.columns = expiredDeals;
          let option = "o";
          this.GetDetailsData(option);
          break;
        }

        case "Cierres de la semana": {
          this.columns = expiredDeals;
          let option = "w";
          this.GetDetailsData(option);
          break;
        }
        case "Cierres Del Mes": {
          this.columns = expiredDeals;
          let option = "m";
          this.GetDetailsData(option);
          break;
        }
        case "Instalaciones Abiertas": {
          this.columns = RequestInstalations;
          let option = "i";
          this.GetDetailsData(option);
          break;
        }
        case "Instalaciones Cerradas del Mes": {
          this.columns = RequestInstalations;
          let option = "c";
          this.GetDetailsData(option);
          break;
        }
        case "Citas de la Semana": {
          this.columns = diaryColumns;
          let option = "d";
          this.GetDetailsData(option);
          break;
        }
        case "Citas del Mes": {
          this.columns = diaryColumns;
          let option = "p";
          this.GetDetailsData(option);
          break;
        }
        case "Aniversarios de Contactos": {
          this.columns = missingAnniversaryColumns;
          let option = "a";
          this.GetDetailsData(option);
          break;
        }
        case "Contactos sin fecha de cumpleaños": {
          this.columns = missingAnniversaryColumns;
          let option = "f";
          this.GetDetailsData(option);
          break;
        }

        case "Prospecciones de la Semana": {
          this.columns = ProspectAndOther;
          let option = "r";
          this.GetDetailsData(option);
          break;
        }

        case "Prospecciones del Mes": {
          this.columns = ProspectAndOther;
          let option = "s";
          this.GetDetailsData(option);
          break;
        }

        case "Presentaciones de la Semana": {
          this.columns = ProspectAndOther;
          let option = "t";
          this.GetDetailsData(option);
          break;
        }

        case "Presentaciones del Mes": {
          this.columns = ProspectAndOther;
          let option = "u";
          this.GetDetailsData(option);
          break;
        }

        case "Ventas de la Semana": {
          this.columns = ProspectAndOther;
          let option = "k";
          this.GetDetailsData(option);
          break;
        }

        case "Ventas del Mes": {
          this.columns = ProspectAndOther;
          let option = "j";
          this.GetDetailsData(option);
          break;
        }

        default: {
          console.error("no matchan los titulos de la columna");
          break;
        }
      }

      // this.items = items;
      // this.columns = columns;customerColumnsCards

      this.drawer = true;
    },
    OnClose() {
      this.items = [];
      this.itemQuantity = 0;
    },
    CloseDetailDrawer() {
      this.dealDetailDrawer = false;
    },

    handleTableUpdate() {
      this.getItems();
      this.$emit("getUpdatedData");
    },
    GetOportunitiesData() {
      this.loading = true;
      //const date = new Date();
      const url = "/api/deals/DealReportByPhase";
      const parameters = {
        params: {
          companyID: this.currentCompany,
          Year: null,
          DealsMonth: null,
          SellerId: this.currentUser.PersonCode,
          PhaseID: null,
          DateFilter: 4,
          UserID: null,
          Close: true,
          limit: 9999,
          Page: 1,
          //BySeller: this.detailProps.BySeller,
          //SellerId: this.detailProps.row.SellerId,
          SupportSellerId: this.currentUser.UserID,
          AgentId: null
        }
      };
      this.$http
        .get(url, parameters)
        .then((resp) => {
          /*
          console.log("Empleado: ", this.employee);
          console.log("Usuario: ", this.currentUser);
          console.log("Respuesta: ", resp);
          console.log("Rol: ", this.roles);
          console.log("Saller Id: ", this.sellerId);
          */

          let { Items } = resp.data;
          this.OportuinitiesData = Items;
        })
        .catch((err) => {
          console.error("Error: ", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ChangeRow() {
      return "rowline";
    }
  },
  computed: {
    //Estas propiedades computadas se utilizan para conseguir los totales de reportes, cantidad y monto de todos los registros.
    getTotalReports() {
      let total = 0;
      if (this.items) {
        total = this.items.length;
      }
      return total;
    },
    getTotalAmount() {
      let total = 0;
      if (this.items) {
        this.items.forEach((i) => (total += i.TotalAmount));
      }
      return total;
    },
    getTotalAmount2() {
      let total = 0;
      if (this.items) {
        this.items.forEach((i) => (total += i.TotalAmount));
      }
      return total;
    },
    getTotalQuantity() {
      let total = 0;
      if (this.items) {
        this.items.forEach((i) => (total += i.Quantity));
      }
      return total;
    }
  },
  watch: {
    refreshStat() {
      this.getReportData();
    },
    employee() {
      this.getReportData();
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
.box-card.activity {
  width: 100%;

  .el-card__header {
    // background: #2484c4;
    padding: 0;

    .clearfix {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      align-items: center;
      font-weight: 900;
      font-size: 14px;
      text-transform: uppercase;
      color: #ffffff;
      margin: 0;
      padding: 0;

      &.stats {
        background: $text-color-accent;
      }

      button {
        float: right;
        align-self: flex-end;
        padding: 3px 0;
        color: #ffffff;

        span {
          padding-bottom: 6px;
        }
      }
    }
  }
}
/*
.rowline {
  margin-bottom: 0px;
  margin: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 100px;
}

.el-table_1_column_1
  .el-table_1_column_2
  .el-table_2_column_3
  .el-table_2_column_4 {
  padding-bottom: 0px;
  padding-top: 0px;
}
*/

.cell {
  line-height: 13px !important;
}
</style>
